import fetch from 'isomorphic-fetch';
import { getQueryParams } from 'shared/helpers';
import hasInvalidInteraction from './onLoad/hasInvalidInteraction';
import { onLoadSharedImpl } from './onLoadShared';
import handleReferral from './onLoad/handleReferral';

export async function getToken(code) {
  const response = await fetch('/api/v1/oidc/token', {
    method: 'POST',
    body: new URLSearchParams({
      client_id: 'pricepoint',
      grant_type: 'authorization_code',
      redirect_uri: `${window.location.origin}${window.location.pathname}`,
      code,
    }),
  });
  const token = await response.json();
  return token;
}

export default function onLoad() {
  return async () => {
    const { code, interaction, referral } = getQueryParams();

    handleReferral(referral, interaction);

    if (code) {
      const token = await getToken(code);
      if (token.access_token) {
        localStorage.setItem('auth-token', token.access_token);
      }
    }

    if (await onLoadSharedImpl()) {
      return;
    }

    if (await hasInvalidInteraction(interaction)) {
      window.location = `/api/v1/oidc/auth?client_id=pricepoint&redirect_uri=${window
        .location.origin}/login/success&scope=openid&response_type=code&nonce=nonce&claims=${JSON.stringify({
        userinfo:
         {
           id: null,
         },
      })}`;
    }
  };
}
